import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface ChatBottomBannerProps {
  children: React.ReactNode;
  className?: string;
}

export const ChatBottomBanner = ({
  children,
  className = "",
  ...props
}: ChatBottomBannerProps) => (
  <div
    {...props}
    className={classNames(
      "bg-tertiary text-dark mx-6 mb-3 rounded-lg p-4 text-center text-sm",
      className,
    )}
  >
    {children}
  </div>
);
